<div class="mr-16" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
  <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-button ">
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-icon-button class="mat-primary-bg mat-elevation-z2 theme-options-button"
        (click)="markNotificationAsRead()" [class.shake]="_dashboardNotificationService.isNotificationActive">
        <mat-icon>notifications_active</mat-icon>
      </button>
    </div>
  </button>
  <mat-menu #userMenu="matMenu" [overlapTrigger]="false" xPosition="after">
    @if(notificationList.length > 0){
    <div>
      @for (item of notificationList; track item) {
        <span mat-menu-item>{{item}}</span>
      }     
    </div>
    }
    @if(notificationList.length <= 0){ <div>
      <span mat-menu-item>No new notifications</span>
</div>
}
</mat-menu>
</div>